import http from "@/api";

/**
 * 連線權杖檢查
 */
export const getSession = () => {
    return http.get(`/api/session`, {} , {
        opts: {
            builtIn: {
                loadingMask: false
            }
        }
    });
};

/**
 * 建立連線權杖
 */
export const createLogin = (
    no
) => {
    return http.get(`/api/session/create/${no}`);
};

/**
 * 提交 - 連線權杖銷毀 (登出)
 */
export const destroySession = () => {
    return http.delete(`/api/session/destroy`, {}, {
        opts: {
            builtIn: {
                failure: false
            }
        }
    });
};
